<script>
	import { Modal, ModalBody, ModalHeader } from "sveltestrap";
	import Navbar from "../SpiritualComponents/Navbar.svelte";
  
	import Services from "../SpiritualComponents/Services.svelte";
	import Features from "../SpiritualComponents/Features.svelte";
	import Team from "../SpiritualComponents/Team.svelte";
	import Testimonial from "../SpiritualComponents/Testimonial.svelte";
	import Blog from "../SpiritualComponents/Blog.svelte";
	import Contact from "../SpiritualComponents/Contact.svelte";
	import Footer from "../SpiritualComponents/Footer.svelte";
	import Switcher from "../SpiritualComponents/Switcher.svelte";
  
	import data from "../Data/wellness_data";
  
	let open = false;
	/**
	 * Toggle modal
	 */
	const toggle = () => {
	  open = !open;
	};
  
  </script>
  
  <!-- STRAT NAVBAR -->
  <Navbar />
  <!-- END NAVBAR -->
  <!--START HOME-->
  
  <section
	class="section bg-home-spiritual home-half active common-section"
	id="home"
	data-image-src="images/bg-home.jpg">
	<div class="bg-overlay-spiritual" />
	<div class="display-table">
	  <div class="display-table-cell">
		<div class="container">
		  <div class="row justify-content-center">
			<div class="col-lg-8 text-white text-center">
			  <h1 class="home-title">Be the best version of yourself.</h1>
			  <p class="pt-3 home-desc">
				Connect. Transform. Inspire.
			  </p>
			  <!-- <p class="play-shadow mt-4" on:click={toggle}>
				<a href={"#"} class="play-btn video-play-icon"
				  ><i class="mdi mdi-play text-center" /></a
				>
			  </p>
			  <Modal isOpen={open} size="lg" {toggle}>
				<ModalHeader {toggle} />
				<ModalBody>
				  <video
					id="VisaChipCardVideo"
					class="video-box"
					src="https://www.w3schools.com/html/mov_bbb.mp4"
					controls
				  >
					<track default kind="captions" type="video/mp4" />
				  </video>
				</ModalBody>
			  </Modal> -->
			  <!-- Modal -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
	<div class="bg-pattern-effect">
	  <img src="images/bg-pattern.png" alt="" />
	</div>
  </section>
  
  <!--END HOME-->
  
  <Services serviceData={data.SERVICE_DATA} />
  <Features featureData={data.FEATURES_DATA} />
  <!-- <Pricing pricingData={data.PRICING_DATA} /> -->
  <Team teamData={data.TEAM_DATA} />
  <Testimonial testimonialData={data.TESATIMONIAL_DATA} />
  <Blog blogData={data.BLOG_DATA} />
  <Contact />
  <Footer />
  <Switcher />
  